import "./Table.scss";
import Skeleton from "../skeletonLoader/SkeletonLoader";

function Table({ columns, data, title, onClick, buttonName, isLoading }) {
  const renderCell = (col, row, rowIndex) => {
    const value =
      typeof col.render === "function" ? col.render(row[col.key], row, rowIndex) : row[col.key];

    return value ?? "-";
  };

  const TableRowSkeleton = () => (
    <div className="custom-table-row-skeleton">
      <Skeleton className="custom-table-row-skeleton-cell custom-table-row-skeleton-icon" />
      <Skeleton className="custom-table-row-skeleton-cell" />
      <Skeleton className="custom-table-row-skeleton-cell" />
      <Skeleton className="custom-table-row-skeleton-cell" />
    </div>
  );

  if (isLoading) {
    return (
      <div className="custom-table-skeleton">
        <Skeleton className="custom-table-skeleton-header" />

        <div className="custom-table-skeleton-container">
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
        </div>
      </div>
    );
  }

  return (
    <div className="custom-table">
      {title && (
        <div className="custom-table-header">
          <p>{title}</p>
          {onClick && buttonName && <button onClick={onClick}>{buttonName}</button>}
        </div>
      )}

      <div className="custom-table-container">
        <table>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={Math.random()}>
                {columns.map((col) => (
                  <td key={col.key}>{renderCell(col, row, index)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Table;
